<template>
  <b-tab
    title="Destinatario"
    :active="isTheCurrentTab"
    :disabled="!isTheCurrentTab && !store.isUpdate"
    class="mt-5"
    @click="() => (store.currentTab = 1)"
  >
    <b-row>
      <b-col sm="6">
        <b-form-group label="Cliente" label-for="nome">
          <VueSelect
            ref="buscarCliente"
            :filterable="false"
            :state="validateClienteState('nome')"
            @input="setCliente"
            :class="{ hasErrors: clienteError, inputFilled: clienteFilled }"
            :options="clientes"
            @search="onSearchCliente"
            :value="form.nome"
            :clearSearchOnSelect="true"
          >
            <template slot="no-options"> Informe o nome do cliente </template>
            <template slot="option" slot-scope="option">
              <div class="d-flex justify-content-between">
                <div>{{ option.codigo }} - {{ option.nome }}</div>
                <span class="text-muted"
                  >CPF: {{ formatCpfCnpj(option.cnpj_cpf) }}</span
                >
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.label }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <button
          ref="add_buyer"
          class="btn btn-primary font-weight-bold w-100"
          v-b-modal.newClientNfe
          style="font-size: 11px; margin-top: 30px; white-space: nowrap"
        >
          Novo Cliente
        </button>
      </b-col>
      <b-col sm="4" v-if="!form.estrangeiro">
        <b-form-group label="CPF/CNPJ" label-for="cnpj_cpf">
          <b-form-input
            v-if="hasCnpjAlfanumerico(form.cnpj_cpf)"
            :key="`${keyToReRender}-alfa`"
            disabled
            id="cnpj_cpf"
            name="cnpj_cpf"
            :value="formatCnpjAlfanumerico(form.cnpj_cpf)"
            :state="validateClienteState('cnpj_cpf')"
          >
          </b-form-input>
          <b-form-input
            v-else
            :key="`${keyToReRender}-numeric`"
            disabled
            id="cnpj_cpf"
            name="cnpj_cpf"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="form.cnpj_cpf"
            :state="validateClienteState('cnpj_cpf')"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="form.estrangeiro">
      <b-col sm="5">
        <b-form-group label="Logradouro" label-for="logradouro_estrangeiro">
          <b-form-input
            id="logradouro_estrangeiro"
            name="logradouro_estrangeiro"
            v-model="form.logradouro_estrangeiro"
            disabled
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="2">
        <b-form-group label="Número" label-for="numero_estrangeiro">
          <b-form-input
            id="numero_estrangeiro"
            name="numero_estrangeiro"
            v-model="form.numero_estrangeiro"
            disabled
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="Bairro" label-for="bairro_estrangeiro">
          <b-form-input
            id="bairro_estrangeiro"
            name="bairro_estrangeiro"
            v-model="form.bairro_estrangeiro"
            disabled
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="UF" label-for="uf_estrangeiro">
          <b-form-input
            id="uf_estrangeiro"
            name="uf_estrangeiro"
            v-model="form.uf_estrangeiro"
            disabled
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="País" label-for="pais_estrangeiro">
          <b-form-input
            id="pais_estrangeiro"
            name="pais_estrangeiro"
            v-model="form.pais_estrangeiro"
            disabled
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row
      v-if="form.estrangeiro && store.formNatureza.cfop.substring(0, 1) === '7'"
    >
      <b-col sm="4">
        <b-form-group label="Local do embarque" label-for="local_embarque">
          <b-form-input
            id="local_embarque"
            name="local_embarque"
            v-model="form.local_embarque"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="1">
        <b-form-group label="UF" label-for="uf_embarque">
          <b-form-input
            id="uf_embarque"
            name="uf_embarque"
            v-model="form.uf_embarque"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="Local do despacho" label-for="local_despacho">
          <b-form-input
            id="local_despacho"
            name="local_despacho"
            v-model="form.local_despacho"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="isCnpjValue(form.cnpj_cpf)">
      <b-col sm="6">
        <b-form-group
          id="identificador_ie"
          label-for="identificador_ie"
          label="Indicador de IE"
        >
          <select
            name="identificador_ie"
            id="identificador_ie"
            v-model="form.identificador_ie"
            class="form-control"
            @change="setIe()"
          >
            <option
              v-for="(i, index) in identificadores_ie"
              :value="i.id"
              :key="'identificador' + index"
            >
              {{ i.descricao }}
            </option>
          </select>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group label="IE" label-for="ie_rg">
          <b-form-input
            :key="keyToReRender"
            id="ie_rg"
            name="ie_rg"
            v-mask="['#################']"
            v-model="form.ie_rg"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!form.estrangeiro">
      <b-col sm="9">
        <b-form-group
          :key="keyToReRender"
          label="Endereço"
          label-for="endereco"
        >
          <VueSelect
            ref="endereco"
            :filterable="false"
            @input="setEndereco"
            :options="enderecos"
            :class="{ hasErrors: enderecoError, inputFilled: enderecoFilled }"
            @search="onSearchEndereco"
            :value="formatEndereco(form.endereco)"
            :state="validateClienteState('endereco')"
          >
            <template slot="no-options"> Informe o Endereço </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{
                  `${option.cep ?? ""}, ${option.logradouro ?? ""}, ${
                    option.numero ?? ""
                  }, ${option.complemento ?? ""},
                  ${option.bairro ?? ""} - ${option?.cidade?.cidade ?? ""} / ${
                    option?.cidade?.uf ?? ""
                  }`
                }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.label }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <button
          type="button"
          class="btn btn-light-primary font-weight-bold w-100"
          style="font-size: 11px; margin-top: 30px"
          :disabled="!form.id_pessoa || !form.endereco"
          @click="abrirModalEditarEndereco"
        >
          Editar endereço
        </button>
      </b-col>
    </b-row>
    <b-row v-if="!form.estrangeiro">
      <b-col sm="10">
        <b-form-group
          :key="keyToReRender"
          label="Endereço de entrega"
          label-for="enderecoEntrega"
        >
          <template #label>
            Endereço de entrega
            <b-icon
              icon="info-circle"
              variant="primary"
              v-b-tooltip="
                'Selecionar somente se for fazer entrega em outro local'
              "
            ></b-icon>
          </template>
          <VueSelect
            ref="enderecoEntrega"
            :filterable="false"
            @input="setEnderecoEntrega"
            :options="enderecos"
            @search="onSearchEndereco"
            :value="formatEnderecoEntrega(form.enderecoEntrega)"
          >
            <template slot="no-options"> Informe o Endereço </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{
                  `${option.cep ?? ""}, ${option.logradouro ?? ""}, ${
                    option.numero ?? ""
                  }, ${option.complemento ?? ""},
                  ${option.bairro ?? ""} - ${option?.cidade?.cidade ?? ""} / ${
                    option?.cidade?.uf ?? ""
                  }`
                }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.label }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="!form.estrangeiro">
      <b-col sm="5">
        <b-form-group :key="keyToReRender" label="E-mail" label-for="email">
          <VueSelect
            ref="buscarNatureza"
            :filterable="false"
            @input="setEmail"
            :options="emails"
            :class="{ hasErrors: emailError, inputFilled: emailFilled }"
            @search="onSearchEmail"
            :value="form.email"
          >
            <template slot="no-options"> Informe o E-mail </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.email }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.email }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col sm="5">
        <b-form-group :key="keyToReRender" label="Telefone" label-for="fone">
          <VueSelect
            ref="fone"
            :filterable="false"
            :options="fones"
            @input="setFone"
            v-model="form.fone"
          >
            <template slot="no-options"> Informe o Telefone </template>
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.fone }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.fone }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="Contato" label-for="contato">
          <b-form-input
            id="contato"
            name="contato"
            v-model="form.contato"
            :state="validateClienteState('contato')"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="2" style="margin-top: 35px" v-if="form.tipo_atacado">
        <span class="label label-lg label-inline label-light-warning"
          >Tipo Atacado</span
        >
      </b-col>
    </b-row>
    <b-row v-if="limiteCreditoAtigindo">
      <b-col sm="12">
        <span class="label label-lg label-inline label-light-danger"
          >Limite de crédito atingido</span
        >
        -
        <span
          ><strong
            >Limite: R$ {{ numberToReal(valorLimiteCredito, 2) }}</strong
          ></span
        >
        /
        <span
          v-b-tooltip.righttop="
            'O limite de crédito considera contas a receber na situação (Em aberto)'
          "
          ><strong
            >Atingido: R$
            {{ numberToReal(valorLimiteCreditoAtingido, 2) }}</strong
          ></span
        >
      </b-col>
    </b-row>
    <b-row v-if="form.produtor_rural && store.tpNF == 0">
      <b-col sm="4">
        <b-form-group label="Número" label-for="numeroNF">
          <b-form-input
            id="numeroNF"
            name="numeroNF"
            v-model="rural.numeroNF"
            type="number"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="Série" label-for="serie">
          <b-form-input
            id="serie"
            name="serie"
            v-model="rural.serie"
            type="number"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group label="Selecione o modelo" label-for="modelo">
          <select
            name="modelo"
            id="modelo"
            v-model="rural.modelo"
            class="form-control"
          >
            <option
              v-for="(m, index) in modelosProdutor"
              :value="m.modelo"
              :key="'id' + index"
            >
              {{ m.modelo }}
            </option>
          </select>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group label="Mês" label-for="mes">
          <b-form-input
            id="mes"
            name="mes"
            v-model="rural.mes"
            v-mask="'##'"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group label="Ano" label-for="ano">
          <b-form-input
            id="ano"
            name="ano"
            v-model="rural.ano"
            v-mask="'####'"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="10" v-if="rural.modelo == 55">
        <b-form-group label="Chave de Acesso da NFe" label-for="chave">
          <b-form-input
            id="chave"
            name="chave"
            v-model="rural.chave"
            type="number"
            :formatter="formatKeyProdutor"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row v-if="listaPreco">
      <b-col>
        <p class="text-muted">
          Lista de preço aplicada:
          <span class="font-weight-bold text-primary">{{
            listaPreco.descricao
          }}</span>
        </p>
      </b-col>
    </b-row>
    <b-row v-if="isCnpjValue(form.cnpj_cpf)">
      <b-col>
        <p class="text-muted">
          Tributação/Revenda:
          <b-icon
            icon="info-circle"
            variant="primary"
            v-b-tooltip="
              'Ao selecionar essa opção irá buscar a tributação de revenda'
            "
          ></b-icon>
          <span class="switch switch-icon">
            <label v-b-tooltip.hover.right="'Não/Sim'">
              <input type="checkbox" v-model="form.tributacao_revenda" />
              <span></span>
            </label>
          </span>
        </p>
      </b-col>
    </b-row>

    <NovoClienteModal
      modal-id="newClientNfe"
      @selected="handleNovoClienteSelected"
    />

    <SelecionarInscricaoEstadualModal
      ref="selecaoIeModal"
      modal-id="selecaoIeNfe"
      :ie-principal="form.ie_rg"
      :endereco-principal="form.enderecos?.[0] || form.endereco || null"
      :inscricoes-adicionais="form.inscricoes_estaduais"
      @selected="handleSelecaoInscricaoEstadual"
    />

    <b-modal id="editAddressNfe" size="lg" centered title="Editar endereço">
      <b-row>
        <b-col md="4">
          <b-form-group label="CEP" label-for="editarEnderecoCep">
            <b-form-input
              id="editarEnderecoCep"
              name="editarEnderecoCep"
              v-model="enderecoEditado.cep"
              v-mask="['#####-###']"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group style="margin-top: 30px">
            <button
              type="button"
              class="btn btn-primary font-weight-bold"
              @click="consultaCepEnderecoEditado"
            >
              Consultar CEP
            </button>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Número" label-for="editarEnderecoNumero">
            <b-form-input
              id="editarEnderecoNumero"
              name="editarEnderecoNumero"
              v-model="enderecoEditado.numero"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Bairro" label-for="editarEnderecoBairro">
            <b-form-input
              id="editarEnderecoBairro"
              name="editarEnderecoBairro"
              v-model="enderecoEditado.bairro"
            />
          </b-form-group>
        </b-col>
        <b-col md="5">
          <b-form-group label="Logradouro" label-for="editarEnderecoLogradouro">
            <b-form-input
              id="editarEnderecoLogradouro"
              name="editarEnderecoLogradouro"
              v-model="enderecoEditado.logradouro"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group
            label="Complemento"
            label-for="editarEnderecoComplemento"
          >
            <b-form-input
              id="editarEnderecoComplemento"
              name="editarEnderecoComplemento"
              v-model="enderecoEditado.complemento"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Cidade" label-for="editarEnderecoCidade">
            <VueSelect
              label="cidade"
              v-model="cidadeEnderecoEditado"
              :options="cidadesEnderecoEditado"
              @input="setCidadeEnderecoEditado"
              @search="onSearchCidadeEnderecoEditado"
            >
              <template slot="no-options"> Informe o nome da cidade </template>
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.cidade + " - " + option.uf }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                  {{ option.cidade + " - " + option.uf }}
                </div>
              </template>
            </VueSelect>
          </b-form-group>
        </b-col>
      </b-row>
      <template #modal-footer="{ cancel }">
        <b-button
          @click="
            () => {
              cancel();
              resetEnderecoEditadoForm();
            }
          "
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          ref="saveAddress"
          @click="salvarEnderecoCliente"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import ClienteData, { ClienteDataRequired } from "../ClienteData";
import RuralData, { RuralDataRequired } from "../RuralData";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeNfe";
import NovoClienteModal from "@/modules/Pessoa/components/NovoClienteModal.vue";
import SelecionarInscricaoEstadualModal from "@/modules/Pessoa/components/SelecionarInscricaoEstadualModal.vue";

export default {
  name: "app-nfe-form-clienteTab",
  components: {
    VueSelect,
    NovoClienteModal,
    SelecionarInscricaoEstadualModal,
  },
  directives: {
    mask,
  },
  data() {
    return {
      listaPreco: null,
      form: {},
      clientes: [],
      emails: [],
      cliente: null,
      ieOptions: ["Contribuinte", "Isento", "Não contribuinte"],
      identificadores_ie: [
        {
          id: 1,
          descricao: "Contribuinte",
        },
        {
          id: 2,
          descricao: "Isento",
        },
        {
          id: 9,
          descricao: "Não Contribuinte",
        },
      ],
      enderecos: [],
      keyToReRender: 0,
      fones: null,
      isCnpj: false,
      store,
      clienteError: false,
      enderecoError: false,
      emailError: false,
      emailFilled: false,
      clienteFilled: false,
      enderecoFilled: false,
      rural: {},
      modelosProdutor: [
        {
          id: 1,
          modelo: "01",
        },
        {
          id: 2,
          modelo: "04",
        },
        {
          id: 3,
          modelo: "55",
        },
      ],
      limiteCreditoAtigindo: false,
      valorLimiteCredito: 0,
      valorLimiteCreditoAtingido: 0,
      enderecoEditado: {},
      enderecoEditadoOriginal: null,
      enderecoEditadoIndex: -1,
      cidadeEnderecoEditado: null,
      cidadesEnderecoEditado: [],
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  validations: {
    form: ClienteDataRequired,
    rural: RuralDataRequired,
  },
  methods: {
    ...mapActions(["setLoading"]),
    // Foca o campo de cliente para o usuario digitar sem precisar do mouse.
    // O conteudo do b-tab e o input do vue-select podem nao estar prontos
    // (ou a aba ainda estar ativando) ao trocar de aba, por isso ha retry que
    // so para quando o foco realmente "pega".
    focarCliente() {
      if (this._clienteFocusTries) {
        clearTimeout(this._clienteFocusTries);
      }
      let tentativas = 0;
      const tentar = () => {
        tentativas++;
        const ref = this.$refs.buscarCliente;
        const input = ref && ref.$el ? ref.$el.querySelector("input") : null;
        const pronto = input && !input.disabled && input.offsetParent !== null;
        if (pronto) {
          input.focus();
          if (document.activeElement === input) return;
        }
        if (tentativas < 20) {
          this._clienteFocusTries = setTimeout(tentar, 50);
        }
      };
      this.$nextTick(tentar);
    },
    onSearchEmail() {},
    setEmail(newEmail) {
      this.form.email = newEmail;
      this.keyToReRender++;
      this.emailFilled = true;
    },
    async calcTotais() {
      const dataSendToApi = this.formatDataToSendToApi(
        this.store.formNatureza,
        this.store.formProduto,
        this.store.formCliente,
        this.store.formFaturamento.pagamentos.length === 0
          ? null
          : this.store.formFaturamento,
        this.store.formImpostos
      );

      const { dados } = await this.getTotaisNfe(dataSendToApi);

      this.store.formImpostos = {
        ...this.store.formImpostos,
        ...dados.total,
      };
    },
    setFone(newFone) {
      this.form.fone = newFone;
      this.keyToReRender++;
    },
    searchEndereco: _.debounce(async (loading, search, vm) => {
      const enderecos = vm.form.enderecos ?? [];
      vm.enderecos = enderecos.filter((endereco) =>
        vm.formatEndereco(endereco).toLowerCase().includes(search.toLowerCase())
      );
      loading(false);
    }, 350),
    onSearchEndereco(search, loading) {
      if (!search.length) {
        this.enderecos = this.form.enderecos ?? [];
        return;
      }

      if (search.length) {
        loading(true);
        this.searchEndereco(loading, search, this);
      }
    },
    setEndereco(endereco) {
      this.form.endereco = endereco;
      this.keyToReRender++;
      this.enderecoFilled = true;
    },
    setEnderecoEntrega(endereco) {
      this.form.enderecoEntrega = endereco;
      this.keyToReRender++;
      this.enderecoFilled = true;
    },
    setIe() {
      if (this.form.identificador_ie == 2) {
        this.form.ie_rg = this.form.ie_rg || "Isento";
      }
    },
    validateClienteState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSearchIndicador(search, loading) {
      loading(true);
      this.searchIndicador(loading, search, this);
    },
    searchIndicador: _.debounce((loading, search, vm) => {
      if (search === "" || search === null) {
        vm.identificadores_ie = [
          {
            id: 1,
            descricao: "Contribuinte",
          },
          {
            id: 2,
            descricao: "Isento",
          },
          {
            id: 3,
            descricao: "Não Contribuinte",
          },
        ];
        return loading(false);
      }
      vm.identificadores_ie = vm.identificadores_ie.filter((option) =>
        option.toLowerCase().includes(search.toLowerCase())
      );
      return loading(false);
    }, 350),
    onSearchCliente(search, loading) {
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchCliente(loading, search, this);
      }
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clientes = [];
      await vm.$nextTick();
      const data = await vm.getClientes(search);
      vm.clientes = _.cloneDeep(data);
      loading(false);
    }, 500),
    setCliente(cliente, validarInadimplencia = true) {
      if (!cliente) return;
      if (
        validarInadimplencia &&
        this.bloquearClienteInadimplenteSelecionado(cliente)
      ) {
        this.form = new ClienteData({});
        this.store.formCliente = this.form;
        this.enderecos = [];
        this.fones = null;
        this.emails = [];
        this.listaPreco = null;
        this.clienteFilled = false;
        this.emailFilled = false;
        this.enderecoFilled = false;
        this.keyToReRender++;
        return;
      }

      this.limiteCreditoAtigindo = false;
      this.valorLimiteCredito = 0;
      this.valorLimiteCreditoAtingido = 0;
      this.listaPreco = null;

      if (cliente?.lista_preco) {
        this.listaPreco = cliente.lista_preco;
      }

      if (cliente.estrangeiro) {
        this.form = cliente;
        this.form.cnpj_cpf = 1;
        this.form.contato = cliente.nome;
        this.form.endereco = cliente.logradouro_estrangeiro;
        this.clienteFilled = true;
        this.emailFilled = true;
        this.enderecoFilled = true;
        return;
      }

      if (
        Object.keys(this.$route.params).length === 0 ||
        this.$route.params.nfeData.buyer.id_pessoa != cliente.id_pessoa
      ) {
        if (cliente.limite_credito > 0) {
          if (
            cliente.limite_de_credito &&
            parseFloat(cliente.limite_credito) <
              parseFloat(cliente.limite_de_credito.valor_total)
          ) {
            this.$toast.warning(
              "Limite de crédito do cliente atingido, verifique!"
            );
            this.getRequestAdmin(() => {
              this.setClienteInadimplente(cliente);
            });
            return;
          }
        }
      }

      this.form = {
        ...cliente,
        cnpj_cpf: this.formatCnpjAlfanumerico(cliente.cnpj_cpf),
        inscricoes_estaduais: Array.isArray(
          cliente.inscricoes_estaduais ?? cliente.inscricoesEstaduais
        )
          ? cliente.inscricoes_estaduais ?? cliente.inscricoesEstaduais
          : [],
      };
      this.form.enderecos = cliente.enderecos ?? cliente.endereco ?? [];
      this.form.fones = cliente.fones ?? cliente.telefone ?? [];
      this.form.emails = cliente.emails ?? cliente.email ?? [];
      this.enderecos = this.form.enderecos;
      this.form.endereco = this.getEnderecoPrincipal(this.enderecos);
      this.fones = this.form.fones;
      this.form.fone = this.form.fones[0] ?? null;
      this.emails = this.form.emails;
      this.form.email = this.emails[0] ?? null;
      this.isCnpj = this.isCnpjValue(this.form.cnpj_cpf);
      this.form.contato = cliente.nome?.split(" ")[0] ?? null;
      this.clienteFilled = true;
      this.emailFilled = true;
      this.enderecoFilled = true;
      if (this.$route.params.nfeData?.tributacao_revenda) {
        this.form.tributacao_revenda =
          this.$route.params.nfeData.tributacao_revenda;
      }

      this.verificarInscricoesEstaduais();
    },
    getEnderecoPrincipal(enderecos = []) {
      return (
        enderecos.find((endereco) => Number(endereco.id_tipo) === 1) ??
        enderecos[0] ??
        null
      );
    },
    verificarInscricoesEstaduais() {
      const temIePrincipal =
        this.form.ie_rg &&
        String(this.form.ie_rg).trim() !== "" &&
        String(this.form.ie_rg).toUpperCase() !== "ISENTO";

      const inscricoesAdicionais = Array.isArray(this.form.inscricoes_estaduais)
        ? this.form.inscricoes_estaduais.filter(
            (inscricao) =>
              inscricao &&
              inscricao.numero_ie &&
              String(inscricao.numero_ie).trim() !== ""
          )
        : [];

      const totalIes = (temIePrincipal ? 1 : 0) + inscricoesAdicionais.length;

      if (totalIes > 1 && this.$refs.selecaoIeModal) {
        this.$nextTick(() => {
          this.$refs.selecaoIeModal.abrir();
        });
      }
    },
    handleSelecaoInscricaoEstadual(inscricaoSelecionada) {
      const numeroIE =
        typeof inscricaoSelecionada === "string"
          ? inscricaoSelecionada
          : inscricaoSelecionada?.numero_ie;

      if (!numeroIE) return;

      const ieSanitizada = String(numeroIE)
        .replace(/[^0-9A-Za-z]/g, "")
        .trim();
      const enderecoSelecionado =
        typeof inscricaoSelecionada === "object"
          ? inscricaoSelecionada?.endereco
          : null;

      const formAtualizado = {
        ...this.form,
        ie_rg: ieSanitizada,
        identificador_ie:
          ieSanitizada && ieSanitizada.toUpperCase() !== "ISENTO"
            ? 1
            : this.form.identificador_ie,
        endereco: enderecoSelecionado ?? this.form.endereco,
      };

      this.form = formAtualizado;
      this.store.formCliente = formAtualizado;
      this.keyToReRender++;

      if (enderecoSelecionado?.logradouro || enderecoSelecionado?.id_cidade) {
        this.enderecoFilled = true;
        this.$toast.success(
          "Endereço atualizado conforme a inscrição estadual selecionada."
        );
      }
    },
    setClienteInadimplente(cliente) {
      this.limiteCreditoAtigindo = true;
      this.valorLimiteCredito = cliente.limite_credito;
      this.valorLimiteCreditoAtingido = cliente.limite_de_credito.valor_total;
      this.form = cliente;
      this.form.identificador_ie = cliente.identificador_ie ?? null;
      this.form.ie_rg = cliente.ie_rg ?? null;

      if (this.form.identificador_ie == 2) {
        this.form.ie_rg = this.form.ie_rg || "Isento";
      }

      this.form.enderecos = cliente.enderecos ?? cliente.endereco ?? [];
      this.form.fones = cliente.fones ?? cliente.telefone ?? [];
      this.form.emails = cliente.emails ?? cliente.email ?? [];
      this.enderecos = this.form.enderecos;
      this.form.endereco = this.getEnderecoPrincipal(this.enderecos);
      this.fones = this.form.fones;
      this.form.fone = this.form.fones[0] ?? null;
      this.emails = this.form.emails;
      this.form.email = this.emails[0] ?? null;
      this.isCnpj = this.isCnpjValue(this.form.cnpj_cpf);
      this.form.contato = cliente.nome?.split(" ")[0] ?? null;
      this.clienteFilled = true;
      this.emailFilled = true;
      this.enderecoFilled = true;
    },
    isCnpjValue(valor) {
      return String(valor || "").replace(/[^A-Z0-9]/gi, "").length >= 14;
    },
    formatEndereco(endereco) {
      if (!endereco) return "";
      const formatData = `${endereco.cep ?? ""}, ${
        endereco.logradouro ?? ""
      }, ${endereco.numero ?? ""}, ${endereco.complemento ?? ""}, ${
        endereco.bairro ?? ""
      } - ${endereco?.cidade?.cidade ?? ""} / ${endereco?.cidade?.uf ?? ""}`;
      return formatData;
    },

    formatEnderecoEntrega(endereco) {
      if (!endereco) return "";
      const formatData = `${endereco.cep ?? ""}, ${
        endereco.logradouro ?? ""
      }, ${endereco.numero ?? ""}, ${endereco.complemento ?? ""}, ${
        endereco.bairro ?? ""
      } - ${endereco?.cidade?.cidade ?? ""} / ${endereco?.cidade?.uf ?? ""}`;

      return formatData;
    },
    formatKeyProdutor(e) {
      return String(e).substring(0, 44);
    },
    handleNovoClienteSelected(cliente) {
      this.setCliente(cliente, false);
    },
    getTipoClienteAtual() {
      const tipos = Array.isArray(this.form.pessoa_tipo)
        ? [...this.form.pessoa_tipo]
        : [];
      const hasCliente = tipos.some(
        (tipo) => tipo.id_tipo === 1 || tipo.id_pessoa_tipo === 1
      );

      if (hasCliente) return tipos;

      return [
        ...tipos,
        {
          id_tipo: 1,
          descricao: "Cliente",
        },
      ];
    },
    buildEnderecoPayload(endereco, cidade, enderecoOriginal = {}) {
      const tipo = enderecoOriginal.tipo ?? {
        id_tipo: enderecoOriginal.id_tipo ?? 1,
        descricao: "Principal",
      };
      const idTipo =
        enderecoOriginal.id_tipo ?? enderecoOriginal.id_endereco_tipo ?? 1;

      return {
        ...enderecoOriginal,
        numero: endereco.numero,
        cep: endereco.cep,
        logradouro: endereco.logradouro,
        bairro: endereco.bairro,
        complemento: endereco.complemento,
        id_endereco_tipo: enderecoOriginal.id_endereco_tipo ?? idTipo,
        id_cidade:
          cidade?.id_cidade ?? endereco.id_cidade ?? enderecoOriginal.id_cidade,
        cidade: cidade ?? endereco.cidade ?? enderecoOriginal.cidade,
        tipo,
        id_tipo: idTipo,
      };
    },
    findEnderecoAtualizado(enderecos, referencia) {
      if (!Array.isArray(enderecos) || enderecos.length === 0) return null;

      const normalizar = (valor) =>
        String(valor ?? "")
          .replace(/\D/g, "")
          .trim();
      const texto = (valor) =>
        String(valor ?? "")
          .trim()
          .toLowerCase();

      return (
        enderecos.find(
          (endereco) =>
            normalizar(endereco.cep) === normalizar(referencia.cep) &&
            texto(endereco.logradouro) === texto(referencia.logradouro) &&
            texto(endereco.numero) === texto(referencia.numero) &&
            texto(endereco.bairro) === texto(referencia.bairro) &&
            texto(endereco.complemento) === texto(referencia.complemento)
        ) ?? null
      );
    },
    abrirModalEditarEndereco() {
      if (!this.form.id_pessoa) {
        this.$toast.warning("Selecione um cliente antes de editar o endereço");
        return;
      }

      if (!this.form.endereco) {
        this.$toast.warning("Selecione um endereço para editar");
        return;
      }

      const enderecosCliente = this.form.enderecos ?? this.enderecos ?? [];
      this.enderecoEditadoIndex = enderecosCliente.findIndex(
        (endereco) => endereco === this.form.endereco
      );
      this.enderecoEditadoOriginal = _.cloneDeep(this.form.endereco);
      this.enderecoEditado = _.cloneDeep(this.form.endereco);
      this.cidadeEnderecoEditado = this.enderecoEditado.cidade ?? null;
      this.cidadesEnderecoEditado = this.cidadeEnderecoEditado
        ? [this.cidadeEnderecoEditado]
        : [];
      this.$bvModal.show("editAddressNfe");
    },
    async salvarEnderecoCliente() {
      this.addLoadingToButton("saveAddress");

      if (!this.cidadeEnderecoEditado?.id_cidade) {
        this.$toast.warning("Selecione a cidade");
        this.removeLoadingToButton("saveAddress");
        return;
      }

      try {
        const enderecoAtualizado = this.buildEnderecoPayload(
          this.enderecoEditado,
          this.cidadeEnderecoEditado,
          this.enderecoEditadoOriginal
        );
        const enderecosAtualizados = [
          ...(this.form.enderecos ?? this.enderecos ?? []),
        ];

        if (this.enderecoEditadoIndex >= 0) {
          enderecosAtualizados.splice(
            this.enderecoEditadoIndex,
            1,
            enderecoAtualizado
          );
        } else {
          enderecosAtualizados.push(enderecoAtualizado);
        }

        const pessoaAtualizada = {
          ...this.form,
          pessoa_tipo: this.getTipoClienteAtual(),
          endereco: enderecosAtualizados,
          enderecos: enderecosAtualizados,
          email: this.form.emails ?? [],
          telefone: this.form.fones ?? [],
        };

        await this.$http.post("/pessoa/update", pessoaAtualizada);

        const { data } = await this.$http.post("/pessoa/find", {
          id_pessoa: this.form.id_pessoa,
        });
        const pessoaResposta = data?.pessoa ?? data?.data ?? data ?? {};
        const enderecosResposta =
          (Array.isArray(pessoaResposta.enderecos) &&
            pessoaResposta.enderecos.length > 0 &&
            pessoaResposta.enderecos) ||
          (Array.isArray(pessoaResposta.endereco) &&
            pessoaResposta.endereco.length > 0 &&
            pessoaResposta.endereco) ||
          enderecosAtualizados;

        const clienteAtualizado = {
          ...pessoaAtualizada,
          ...pessoaResposta,
          enderecos: enderecosResposta,
          fones:
            pessoaResposta.fones ??
            pessoaResposta.telefone ??
            pessoaAtualizada.telefone,
          emails:
            pessoaResposta.emails ??
            pessoaResposta.email ??
            pessoaAtualizada.email,
        };

        this.setCliente(clienteAtualizado, false);
        this.form.endereco =
          this.findEnderecoAtualizado(
            clienteAtualizado.enderecos,
            enderecoAtualizado
          ) ??
          clienteAtualizado.enderecos[this.enderecoEditadoIndex] ??
          clienteAtualizado.enderecos[0] ??
          null;
        this.enderecoFilled = !!this.form.endereco;
        this.keyToReRender++;
        this.$toast.success("Endereço atualizado no cadastro do cliente");
        this.resetEnderecoEditadoForm();
        this.$bvModal.hide("editAddressNfe");
      } catch {
        this.$toast.error("Erro ao salvar endereço");
      }

      this.removeLoadingToButton("saveAddress");
    },
    resetEnderecoEditadoForm() {
      this.enderecoEditado = {};
      this.enderecoEditadoOriginal = null;
      this.enderecoEditadoIndex = -1;
      this.cidadeEnderecoEditado = null;
      this.cidadesEnderecoEditado = [];
    },
    async consultaCepEnderecoEditado() {
      this.setLoading(true);
      const cep = await this.getCep(this.enderecoEditado.cep);

      if (cep.length == 0) {
        this.setLoading(false);
        return;
      }

      this.enderecoEditado = {
        ...this.enderecoEditado,
        logradouro: cep.logradouro,
        bairro: cep.bairro,
      };

      if (cep.erro) {
        this.setLoading(false);
        this.$toast.warning("Confira o CEP informado!");
        return;
      }

      const cidades = await this.getCidadeByUF(cep.localidade, cep.uf);
      this.cidadesEnderecoEditado = cidades;
      this.cidadeEnderecoEditado = cidades[0] ?? null;
      this.setLoading(false);
    },
    setCidadeEnderecoEditado(cidade) {
      this.cidadeEnderecoEditado = cidade;
    },
    onSearchCidadeEnderecoEditado(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCidadeEnderecoEditado(loading, search, this);
      }
    },
    searchCidadeEnderecoEditado: _.debounce(async (loading, search, vm) => {
      vm.cidadesEnderecoEditado = await vm.getCidade(search);
      loading(false);
    }, 350),
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      this.form = new ClienteData({});
      this.rural = this.$route.params.nfeData.rural ?? null;
      const id_pessoa = this.$route.params.nfeData.buyer.id_pessoa;
      this.$http
        .post("/pessoa/find", {
          id_pessoa,
        })
        .then((response) => {
          this.setCliente(response.data, false);
        })
        .catch((error) =>
          this.$toast.error(`Erro ao buscar cliente:\n${error}`)
        );
    } else {
      this.form = new ClienteData({});
      this.rural = new RuralData({});
    }
  },
  mounted() {
    // Ao entrar na aba de destinatario, ja foca o campo de cliente.
    if (this.store.currentTab === 1) {
      this.focarCliente();
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },

    formatEnderecos() {
      const formatData = this.enderecos
        ? this.enderecos.map(
            (endereco, index) =>
              `${index === 0 ? "Principal - " : ""}${endereco.cep ?? ""}, ${
                endereco.logradouro ?? ""
              }, ${endereco.numero ?? ""}, ${endereco.bairro ?? ""} - ${
                endereco?.cidade?.cidade ?? ""
              } / ${endereco?.cidade?.uf ?? ""}`
          )
        : null;
      return formatData;
    },
    isTheCurrentTab() {
      return store.currentTab === 1;
    },
  },
  watch: {
    "store.formCliente"(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.form = newValue;
        this.fones = this.form.fones;
        this.enderecos = this.form.enderecos;
        this.emails = this.form.emails;
        this.keyToReRender++;
        if (!this.form.contato) this.form.contato = newValue.contactPerson;
      }
    },
    "store.formCliente.fone"(newValue, oldValue) {
      this.keyToReRender++;

      if (newValue !== oldValue) {
        this.keyToReRender++;
      }
    },
    form(newValue, oldValue) {
      if (JSON.stringify(newValue) === JSON.stringify(oldValue)) return;
      this.store.formCliente = newValue;
    },
    "store.formRural"(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.rural = newValue;
        this.store.formRural = newValue;
      }
    },
    rural(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.store.formRural = newValue;
      }
    },
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 1) {
        this.focarCliente();
      }
      if (newValue !== oldValue && newValue === 2 && oldValue < newValue) {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          if (this.$v.form.$anyError) {
            this.store.currentTab = oldValue;
            if (this.$v.form.nome.$anyError) {
              this.$toast.error("Informe o cliente!");
              this.clienteError = true;
            }
            if (this.$v.form.endereco.$anyError) {
              this.$toast.error("Informe o endereco do cliente!");
              this.enderecoError = true;
            }
          }
          return;
        } else {
          this.store.formNatureza.cfop === "5929" && this.calcTotais();
        }
      }
    },
  },
};
</script>
